import { Component } from 'react';
import { Sentry } from '@charitystack/shared';
import { Button } from '@/components/ui/button';

/** A failed embedded component must never take the dashboard shell with it. */
export default class StripeEmbedBoundary extends Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch(error) { this.props.onError?.(); Sentry.captureException(error, { tags: { area: 'stripe', operation: 'embedded_component_render' } }); }
  render() {
    if (this.state.failed) return <div role="alert" className="rounded-md border border-edge bg-paper-light p-4 text-sm text-ink-secondary">
      <p>Stripe could not display this section. Your saved information is kept.</p>
      <Button variant="neutral" size="workspace" className="mt-3" onClick={() => this.props.onRetry?.()}>Try again</Button>
    </div>;
    return this.props.children;
  }
}
